module.exports = __webpack_public_path__ + "img/index-security-bottom2.7ccd3ea0.png";